// import 'babel-polyfill';
import "@elsa-zku/lib/helpers/catchChunkLoadError";
import "@elsa-zku/lib/helpers/browserLocalStorage";
import 'destyle.css';
import "@elsa-zku/lib/styles/_colors.scss";
import "@elsa-zku/lib/styles/_fontFaceMontserrat.scss";
import "@elsa-zku/lib/styles/_typography.scss";

import * as React from 'react';
import { render } from 'react-dom';
import * as ws from '@elsa-zku/lib/helpers/websockets';

import routes from "src/routes";
import menu from "src/menu";
import UserAuthGuard from "src/components/UserAuthGuard";
import App from "@elsa-zku/lib/components/App";
import { auth } from "src/store/user";
import { setApiUrl } from "src/api";
import { createRoot } from "react-dom/client";

setApiUrl(process.env.API_V2_URL + '/api/');
ws.init();
auth();

const root = createRoot(document.getElementById('app'));
root.render(<App
  routes={routes}
  menu={menu}
  defaultRouteUrl="/orders"
  baseUrl={process.env.BASE_URL}
  renderRouter={(renderer) => <UserAuthGuard>{renderer}</UserAuthGuard>}
/>);
